import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

// Components
import { SelectComponent } from '@/components/base/Select/SelectComponent/SelectComponent';
import { Button } from '@/components/base/Select/SelectComponent/SubComponents/SelectButton/Button';

const SelectButtonStatusPost = ({ selected }) => {
    const { t } = useTranslation();

    return (
        <Button buttonVariant="whiteWithBorder" size="xs">
            <div className="flex items-center space-x-2">
                {selected?.color ? (
                    <span
                        className="inline-block h-2 w-2 rounded-full"
                        style={{ backgroundColor: selected.color }}
                    />
                ) : null}
                <span className="block flex-1 truncate text-icoBlack dark:text-white">
                    {t(selected.label)}
                </span>
            </div>
        </Button>
    );
};

const SelectOptionStatusPost = ({ option }) => {
    const { t } = useTranslation();
    return (
        <span className="flex items-center space-x-2 text-xs">
            {option.option.color ? (
                <span
                    className="inline-block h-2 w-2 rounded-full"
                    style={{ backgroundColor: option.option.color }}
                />
            ) : null}
            <span className="flex-1 truncate">{t(option.option.label)}</span>
        </span>
    );
};

const SelectFilterStatusPost = ({ statusSelected, statusOptions, onChange }) => {
    return (
        <div className="w-44">
            <SelectComponent
                selected={statusOptions.find((item) => statusSelected === item.value)}
                setSelected={onChange}
                options={statusOptions}
                buttonBaseStyle="grayNoBorder"
                button={({ selected }) => <SelectButtonStatusPost selected={selected} />}>
                {(option) => <SelectOptionStatusPost option={option} />}
            </SelectComponent>
        </div>
    );
};

SelectFilterStatusPost.propTypes = {
    statusSelected: PropTypes.string.isRequired,
    statusOptions: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired
};

export default SelectFilterStatusPost;
